<h1 mat-dialog-title>Produkt löschen</h1>

<div mat-dialog-content>
  <p>Wollen Sie wirklich folgendes Produkt löschen?</p>
  <strong>{{product.name}}</strong>
</div>

<div mat-dialog-actions>
  <button mat-button (click)="cancel()" cdkFocusInitial
         [attr.data-action]="'cancel-delete-product'">Abbrechen</button>
  <button mat-button [mat-dialog-close]="product.id"
         [attr.data-action]="'confirm-delete-product'">Ja, löschen</button>
</div>
